export { default as Singleton } from './Singleton';